import React from 'react';
import './Blog.css';
import MessiImage from '../assets/images/Messi.jpg';

function Blog() {
  // Datos de ejemplo para los artículos del blog
  const blogPosts = [
    {
      id: 1,
      slug: "asegura-tus-boletos-al-mundial-2026",
      title: "Asegura tus boletos al mundial 2026 antes de qué suban los precios — RTB Collect",
      excerpt: "El Mundial de la FIFA es el evento deportivo más esperado del planeta. Descubre por qué esperar para comprar boletos es la peor idea y cómo los RTB pueden ayudarte a asegurar tu entrada.",
      date: "20 Oct 2024",
      readTime: "8 min",
      category: "RTB",
      image: MessiImage
    }
  ];

  return (
    <div className="blog">
      <div className="blog__header">
        <h1>Blog RTB Collect</h1>
        <p>Mantente al día con las últimas noticias, guías y análisis del mundo de los coleccionables digitales</p>
      </div>

      <div className="blog__grid">
        {blogPosts.map(post => (
          <article key={post.id} className="blog__post card">
            <div className="blog__postImage">
              <img src={post.image} alt={post.title} />
              <div className="blog__postCategory">
                <span className="badge badge-primary">{post.category}</span>
              </div>
            </div>
            <div className="blog__postContent">
              <h3 className="blog__postTitle">{post.title}</h3>
              <p className="blog__postExcerpt">{post.excerpt}</p>
              <div className="blog__postMeta">
                <span className="blog__postDate">{post.date}</span>
                <span className="blog__postReadTime">{post.readTime} de lectura</span>
              </div>
                  <a href={`/blog/${post.slug}`} className="btn btn-primary">Leer más</a>
            </div>
          </article>
        ))}
      </div>

      <div className="blog__cta">
        <h2>¿Quieres escribir para nosotros?</h2>
        <p>Si tienes experiencia en trading de RTB y quieres compartir tu conocimiento, contáctanos.</p>
        <a href="/support" className="btn btn-secondary">Contactar</a>
      </div>
    </div>
  );
}

export default Blog;
